import GlyphIcon from "./GlyphIcon.mjs";

/** @type {GlyphIcon} */
const HomeIcon = class extends GlyphIcon {
	render() {
		return(
			<GlyphIcon
				{...this.props}
				d="M26.858,17H24V27.5a.5.5,0,0,1-.5.5h-4a.5.5,0,0,1-.5-.5v-5a.5.5,0,0,0-.5-.5h-5a.5.5,0,0,0-.5.5v5a.5.5,0,0,1-.5.5h-4a.5.5,0,0,1-.5-.5V17H5.142a.5.5,0,0,1-.36737-.83911L15.63257,4.398a.50006.50006,0,0,1,.73486,0l10.858,11.76294A.5.5,0,0,1,26.858,17Z"
			/>
		);
	}
}

export default HomeIcon;